<section class="tab-content tab-wrapper ba-bg-bright" *ngIf="kiwi?.length">
    <h2 id="eae_ergebnisHeader_txt">Ihr Abfrageergebnis</h2>

    <div class="ergebnis-header">
        <div id="eae_ihrAngaben_txt"><strong>Ihre Eingaben:</strong></div>

        <div>
            <span id="eae_kindergeldnummer_txt">Kindergeldnummer: </span>
            <span id="eae_kindergeldnummer">{{ kiwi[0].anfrage.kindergeldnummer }}</span>
        </div>

        <div>
            <span id="eae_ordnungskriterium_txt">Ordnungskriterium des Arbeitgebers: </span>
            <span id="eae_ordnungskriterium">{{ kiwi[0].anfrage.ordnungkriterium }}</span>
        </div>

        <div>
            <span id="eae_abfragezeitraum_txt">Abfragezeitraum: </span>
            <span id="eae_abfragezeitraum"
                >{{ kiwi[0].anfrage.anfrageZeitraumVon | date: 'MM.yyyy' }} -
                {{ kiwi[0].anfrage.anfrageZeitraumBis | date: 'MM.yyyy' }}</span
            >
        </div>
    </div>

    <table class="ba-table">
        <thead>
            <tr>
                <th id="eae_tabelleHeaderGeburtsdatum">Geburtsdatum</th>
                <th id="eae_tabelleHeaderVorname">Vorname</th>
                <th id="eae_tabelleHeaderBefristungsdatum">Befristungstermin</th>
                <th id="eae_tabelleHeaderAbfragezeitraum">Zeitraum</th>
                <th id="eae_tabelleHeaderAnspruchshoehe">Anspruchshöhe</th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let kind of kiwi; let i = index">
                <td data-head="Geburtsdatum" id="eae_kindGeburtsdatum_{{ i }}">
                    {{ kind.anfrage.kindGeburtsdatum | date: 'dd.MM.yyyy' }}
                </td>
                <td data-head="Vorname" id="eae_vorname_{{ i }}">
                    {{ kind.anfrage.kindVorname }}
                </td>
                <td data-head="Befristungsdatum" id="eae_befristungsdatum_{{ i }}">
                    {{ kind.auskunft?.befristungstermin | date: 'MM.yyyy' }}
                </td>
                <ng-container *ngIf="kind.auskunft">
                    <td data-head="Abfragezeitraum" id="eae_abfragezeitraum_{{ i }}">
                        <p><strong>Aktuell:</strong></p>
                        <p *ngFor="let zeitraum of kind.auskunft?.zeitraeume">
                            {{ zeitraum?.zeitraumVon | date: 'MM.yyyy' }} -
                            {{ zeitraum?.zeitraumBis | date: 'MM.yyyy' }}
                        </p>
                    </td>
                    <td data-head="Anspruchshöhe" id="eae_anspruchshoehe_{{ i }}">
                        <p>
                            <strong>{{ kind.auskunft?.aktuelleAnspruchshoehe | anspruchshoehe }}</strong>
                        </p>
                        <p *ngFor="let zeitraum of kind.auskunft?.zeitraeume">
                            {{ zeitraum?.anspruchshoehe | anspruchshoehe }}
                        </p>
                    </td>
                </ng-container>
                <ng-container *ngIf="!kind.auskunft">
                    <td colspan="3">
                        Es ist keine Beauskunftung möglich. Bitte überprüfen Sie Ihre eingegebenen Daten, die mit denen
                        der Familienkasse exakt übereinstimmen müssen. Bei Fragen können Sie sich gerne an die
                        Ansprechpartner Ihrer regionalen Familienkasse wenden.
                    </td>
                </ng-container>
            </tr>
        </tbody>
    </table>

    <div class="row">
        <div class="col-sm-12 col-md-6 text-left">
            <px-button buttonStyleType="secondary" id="eae_neueAnfrage" (buttonClicked)="neueAnfrage.emit()"
                >Neue Anfrage</px-button
            >
        </div>
        <div class="col-sm-12 col-md-6 text-right" *ngIf="getUrl() as url">
            <a
                class="ba-btn ba-btn-primary px-button"
                id="eae_downloadFile_btn"
                [href]="url"
                (click)="downloadFile()"
                [attr.download]="filename"
                target="_blank"
                >Als PDF Downloaden</a
            >
        </div>
    </div>
</section>
